import CustomerService from "../Miscellanous/CustomerService";

export default CustomerService;